import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

import { fetchFromAPI } from "../utils/fetchFromAPI";
import { Videos, Sidebar ,Side,SlideVideo} from "./";
import { Link } from "react-router-dom";
import HeroBanner from "./HeroBanner";


function Gaming() {
  const [videos, setVideos] = useState(null);
  const [topVideos,setTopVideos] = useState(null);
    const { selectedCategory } = useParams();
    useEffect(() => {
      console.log(selectedCategory)
        fetchFromAPI(`search?part=snippet&q=Esport`)
        .then((data) => {
          setVideos(data.items)
          setTopVideos(data.items.filter((i) => i.snippet.channelTitle.includes("Esport")).slice(0,5))
          
        
        })
        
    }, []);


    return (
    

      <Stack width="100%" direction="column" justifyContent="center" p={2} sx={{ overflowY: "auto", height: "90vh", flex: 2 }}>
      {topVideos&&<HeroBanner topVideos={topVideos.slice(0, 5)} />}

      <Box maxHeight="10vh">
        

        <Typography variant="h4" fontWeight="bold" mt={1} mb={2} sx={{ color: "white" }}>
          Gaming <span style={{ color: "#FC1503" }}>videos</span>
        </Typography>

        <Videos videos={videos} />

      </Box>
      
    </Stack>
      // </Stack>
    );
}

export default Gaming